import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { H4Text } from '@prisjakt/ui/text/variants';
import { ColorVariantSelectionButton } from './color-variant-selection-button';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { FilterType } from 'src/components/price-list/types';
import type { IVariantsProps } from '../types';
import { VariantGridTitle, ScrollableArea } from '../styles-common';
import { VariantGridWrapper, VariantGridCell } from './styles';

export const ColorVariantsGrid: React.FC<IVariantsProps> = props => {
  const { title, variants, handleSelection, isMobile } = props;
  const { t } = useAppContext();
  const { getFilter } = useOfferListFilterContext();
  const filter = getFilter(FilterType.VARIANT_COLOR);
  const selection = filter?.active ? filter?.selection : undefined;
  const sortedVariants = variants?.filter(Boolean);

  return (
    <div>
      {title && (
        <VariantGridTitle>
          <H4Text>{title}</H4Text>
        </VariantGridTitle>
      )}
      <ScrollableArea>
        <VariantGridWrapper>
          <VariantGridCell $order={0}>
            <ColorVariantSelectionButton
              variant={null}
              title={t('product', 'variants.all')}
              selection={selection}
              handleSelection={handleSelection}
              isMobile={isMobile}
            />
          </VariantGridCell>
          {sortedVariants?.map(variant => (
            <ColorVariantSelectionButton
              variant={variant.color!}
              selection={selection}
              handleSelection={handleSelection}
              disabled={variant.disabled}
              key={variant.color}
              isMobile={isMobile}
            />
          ))}
        </VariantGridWrapper>
      </ScrollableArea>
    </div>
  );
};
